import { Pipe } from '@angular/core';

@Pipe({
  name: 'addDays',
})
export class AddDaysPipe {
  transform(value: string, daysToAdd: number): string {
    const date = new Date(value);
    date.setDate(date.getDate() + daysToAdd);
    return date.toISOString();
  }
}
